function tone(score: number): { bg: string; text: string } {
  if (score >= 70) return { bg: 'bg-emerald-50', text: 'text-emerald-700' };
  if (score >= 45) return { bg: 'bg-amber-50', text: 'text-amber-700' };
  return { bg: 'bg-rose-50', text: 'text-rose-700' };
}

export function ScoreBadge({ score, size = 'sm' }: { score: number; size?: 'sm' | 'lg' }) {
  const { bg, text } = tone(score);
  const sizing = size === 'lg' ? 'h-14 w-14 text-lg' : 'h-9 w-9 text-xs';

  return (
    <div
      className={`flex ${sizing} flex-col items-center justify-center rounded-full font-semibold ${bg} ${text}`}
      title="CasaMetric Score"
    >
      {Math.round(score)}
    </div>
  );
}
